"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// import { getConfigInfo, getUserReservationList } from './mockDate';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const { handleApiError } = require('../../../error-handler');
/**
 * 通用预约组件请求类
 *
 * 注意：fego-render 的 commonApi.get/post 行为：
 * - 当 code === 0 时：返回 res.data
 * - 当 code !== 0 时：Promise.reject(res)，即抛出整个 { code, data, message } 对象
 */
class Request {
    constructor() {
        this.type = 'common-reservation';
        const { request } = require('@futuweb/fego-render').common;
        this.commonApi = request.bindCommonApi(this.type);
    }
    /**
     * 处理 API 错误，显示 Toast 并重新抛出
     * @param error - catch 中捕获的错误对象 { code, data, message }
     * @throws 重新抛出包装后的 Error 对象
     */
    handleError(error) {
        handleApiError(error);
        const wrappedError = new Error(error.message || 'Request failed');
        wrappedError.code = error.code;
        wrappedError.data = error.data;
        throw wrappedError;
    }
    /**
     * 获取配置信息
     * @param params 请求参数
     * @returns 配置信息
     */
    async getConfigInfo(params) {
        // return Promise.resolve(getConfigInfo.data);
        try {
            return await this.commonApi.get('getConfigInfo', params);
        }
        catch (error) {
            this.handleError(error);
        }
    }
    /**
     * 创建预约
     * @param params 请求参数
     * @returns 创建结果
     */
    async createReservation(params) {
        try {
            return await this.commonApi.post('createReservation', params);
        }
        catch (error) {
            this.handleError(error);
        }
    }
    /**
     * 获取用户预约记录列表
     * @param params 请求参数
     * @returns 预约记录列表
     */
    async getUserReservationList(params) {
        // return Promise.resolve(getUserReservationList.data);
        try {
            return await this.commonApi.get('getUserReservationList', params);
        }
        catch (error) {
            this.handleError(error);
        }
    }
    /**
     * 取消预约
     * @param params 请求参数
     * @returns 取消结果
     */
    async cancelReservation(params) {
        try {
            return await this.commonApi.post('cancelReservation', params);
        }
        catch (error) {
            this.handleError(error);
        }
    }
}
exports.default = new Request();
//# sourceMappingURL=data:application/json;base64,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